import { DoubleBetPrevention } from '../../model/double-bet-prevention';
import { IBetslipTeasersErrorState } from '../teaser-bet/models';
import { IPlaceBetSavedPayload, PlaceBetPayloadWithBalance } from './actions';
import { StakeUpdateErrorModel } from './models';
import { TotalStake } from './services/stake/stake-utils';

/**
 * List of states a button can be. We use flags so we can combine states like:
 * AcceptChanges + PlaceBet, Deposit + PlaceBet, Error + other states
 */
/* eslint-disable no-bitwise */
export enum PlaceButtonStates {
    None = 0, // No state, e.g betslip in resulted state
    Login = 1 << 1, // User not logged in
    AcceptChanges = 1 << 2, // Has changes needs to be accepted,
    Deposit = 1 << 3, // Not enough money, make a deposit
    Confirm = 1 << 4,
    PlaceBet = 1 << 5, // Place Bet
    Processing = 1 << 6, // Processing placing bets
    Error = 1 << 7, // Error, can't place bet e.g. empty stake, not selected picks
    UpdateStake = 1 << 8, //minstake error for single pick
    UpdateStakes = 1 << 9, //minstake error for multiple picks
}
/* eslint-enable no-bitwise */

export enum PlaceButtonMode {
    // eslint-disable-next-line no-bitwise
    Processing = 1 << 0,
    // eslint-disable-next-line no-bitwise
    Confirm = 1 << 1,
    // eslint-disable-next-line no-bitwise
    Normal = 1 << 2,
    // eslint-disable-next-line no-bitwise
    Deposit = 1 << 3,
}

export interface IBetslipPlaceBetState {
    doubleBetPrevention: string;
    betInProgress: PlaceBetPayloadWithBalance | null;
}

export interface IBetslipPlaceBetSavedState extends Omit<IBetslipPlaceBetState, 'betInProgress'> {
    betInProgress: IPlaceBetSavedPayload | null;
}

export const defaultBetslipPlaceBetState: IBetslipPlaceBetState = {
    doubleBetPrevention: DoubleBetPrevention.PreventIfSameOdds,
    betInProgress: null,
};
export interface IBetslipPlaceButtonState {
    mode: PlaceButtonMode;
    isValid: boolean;
    isAuthenticated: boolean;
}

export const defaultBetslipPlaceButtonState: IBetslipPlaceButtonState = {
    mode: PlaceButtonMode.Normal,
    isValid: true,
    isAuthenticated: false,
};

export interface IPlaceButtonState {
    hasLivePicks: boolean; //picksState
    hasComboPreventionError: boolean; //errorState error type of ComboPrevention
    oddsChanged: boolean; // check errorrs nese ndryshon dhe nuk eshte pranu
    oddsAccepted: boolean; // similar to OddsAcceptanceEffects
    changedPicks: IPicksChangeState; //picksState
    action: PlaceButtonStates; //internal
    isValid: boolean;
    isProcessing: boolean;
    isFreeBet: boolean;
    stakeUpdateErrors: StakeUpdateErrorModel[];
    teasersErrorState?: IBetslipTeasersErrorState;
    stakes: TotalStake[];
    isLinear: boolean;
}

export interface IPicksChangeState {
    lockedPicks: number;
    unlockedPicks: number;
    closedPicks: number;
    //picks that are invisible but don't have auto unselect/auto remove
    suspendedPicks: number;
}

export const defaultPlaceButtonState: IPlaceButtonState = {
    hasLivePicks: false,
    hasComboPreventionError: false,
    oddsChanged: false,
    oddsAccepted: false,
    changedPicks: { lockedPicks: 0, unlockedPicks: 0, closedPicks: 0, suspendedPicks: 0 },
    action: PlaceButtonStates.PlaceBet,
    isValid: true,
    isFreeBet: false,
    isProcessing: false,
    isLinear: false,
    stakes: [],
    stakeUpdateErrors: [],
};
